export default __webpack_public_path__ + "static/media/OCGO.45ce6456.jpg";